<p-toast></p-toast>

<div class="card dashboardTable">


    <p-table #regVendorListTable [value]="micada1Data" [rows]="10" [paginator]="true" responsiveLayout="scroll" [rowHover]="true"
        dataKey="Email_ID"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" [loading]="loading" styleClass="p-datatable-gridlines"
        [tableStyle]="{'max-width': '80rem'}" [globalFilterFields]="[
        'Vendor_Name',
        'Mobile',
        'Email_ID',
        'GST_No',
        'TAN_No',
        'PAN_No',
        'Status',
        ]">
        <ng-template pTemplate="caption">
            <div class="grid d-flex align-items-center justify-content-end">
                <!-- Left side -->
                <div class="col-6">
                    <h5 class="m-0 table-header-text" [ngStyle]="{'color': 'black'}">{{ tableHeaderName | translate}}
                    </h5>
                </div>
                <!-- Middle section for buttons -->
                <!-- <div class="col-12 md:col-6 d-flex justify-content-center">
                        <label class="pr-2">{{ 'User Filter' }}</label>
                        <p-dropdown [options]="miUnderProcFilterList" appendTo="body" (onChange)="onSelectMIConsFilter()" [(ngModel)]="selectedMIUnderProcFilter"
                            placeholder="{{'ALL'| translate}}" optionLabel="actionLevel" [showClear]="true"></p-dropdown>
                        <button (click)="refreshTable()" pButton pRipple label="" icon="pi pi-refresh" class="p-button-info mx-1"></button>
                    </div> -->
                <!-- Right side for search -->
                <div class="col-12 md:col-6 gap-3 d-flex align-items-center justify-content-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="regVendorListTable.filterGlobal($any($event.target).value, 'contains')" placeholder="{{'SEARCH'| translate}}" />
                    </span>
                    <p-splitButton class="mx-1" [model]="miCompletedReport" icon="pi pi-download" label="{{'EXPORT' | translate}}"></p-splitButton>
                    <!-- <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
                        class="p-button-help mx-1"></button>
                    <p-menu #menu [popup]="true" [model]="miCompletedReport"></p-menu> -->
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th>{{'S_NO'| translate}}
                    <!-- <p-columnFilter type="text" field="Row_No" display="menu"></p-columnFilter>
                    <p-sortIcon field="Row_No"></p-sortIcon> -->
                </th>
                <th pSortableColumn="Vendor_Name">{{'Name'| translate}}</th>
                <th pSortableColumn="Mobile">{{'Mobile'| translate}}</th>
                <th pSortableColumn="Email_ID">{{'Email ID'| translate}}</th>
                <th pSortableColumn="GST_No">{{'GST No'| translate}}</th>
                <th pSortableColumn="TAN_No">{{'TAN No'| translate}}</th>
                <th pSortableColumn="PAN_No">{{'PAN No'| translate}}</th>
                <th>{{'View Components'| translate}}</th>
                <!-- <th pSortableColumn="Village">{{'Village'| translate}}</th> -->
                <th pSortableColumn="Status">{{'Status'| translate}}</th>
                <th>{{'ACTION' | translate}}</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-consolidateData let-ri="rowIndex">
            <tr class="body-section" [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(consolidateData)}">
                <td>{{ ri + 1 }}</td>
                <td>{{consolidateData?.Vendor_Name}}</td>
                <td>{{consolidateData?.Mobile}}</td>
                <td>{{consolidateData?.Email_ID}}</td>
                <td>{{consolidateData?.GST_No}}</td>
                <td>{{consolidateData?.TAN_No}}</td>
                <td>{{consolidateData?.PAN_No}}</td>
                <!-- <td>{{consolidateData?.Village }}</td> -->
                <td class="flex justify-content-center">
                    <button pButton type="button"
                        class="p-button-rounded p-button-accent p-button-primary p-button-rounded"
                        pTooltip="{{ 'VIEW' | translate }}" (click)="selectPhysicalVerAppln(consolidateData, 'viewOnly')" icon="pi pi-eye"></button>
                </td>
                <td>{{consolidateData?.Status}}</td>
                <td>
                    <!-- <button *ngIf="consolidateData?.Status == null || consolidateData?.Status == 'Pending'" pButton pRipple type="button" pTooltip="Add-MI-Verification" icon="pi pi-plus" -->
                    <button pButton pRipple type="button" pTooltip="Add-MI-Verification" icon="pi pi-plus"
                        class="p-button-rounded p-button-text"
                        (click)="selectPhysicalVerAppln(consolidateData, 'action')"></button>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="summary">
            <div class="flex  justify-content-between flex-column ">
                <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{micada1Data ? micada1Data.length : 0 }} {{'VERIFICATION_APPLICATIONS_ADDED'| translate}}.
                </p>
                <div class="flex  justify-content-between flex-column "> 
                    <div class="flex"><div style="background-color:#ffffff ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'Pending'| translate}}</div>
                    <div class="flex"><div style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'Approved'| translate}}</div>
                    <div class="flex"><div style="background-color:#ffb3b3 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'Objection Raised'| translate}}</div>
                    <div class="flex"><div style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'Rejeccted'| translate}}</div>
                </div>
            </div>
        </ng-template>

    </p-table>
</div>